<template>
  <div>
    <i data-icon-name="ChevronLeftMed" aria-hidden="true" class="ms-Icon root-43"></i><span class="yeartext">{{text}}</span>
  </div>
</template>

<script>
export default {
  name: 'BackNavigationScroller',
  props:["text"],
}
</script>

<style scoped>
div{
  color:white;
 
  font-family: "Montserrat Light";
  padding: 8px;
  padding-left: 12px;
  padding-right: 20px;
  padding-top: 8px;
  border-radius: 5px;
  margin-bottom: 12px;



  color: #1976d2;
  font-family: "Montserrat";
  font-size: 16px;
  padding-left: 0px;
  margin-bottom: 0px;

}

div:hover{
  cursor: pointer;
}

i{
  margin-right: 7px;
  font-size: 15px;
}

.yeartext {
  padding-bottom: 10px;
  font-size: 19px;
}





</style>